export default "__VITE_ASSET__Ds5ujD3e__"